import { Component, OnInit } from '@angular/core';
import { DataType } from '@miq/catalog';
import { AbstractAdvancedInput } from '../abstract-advanced-input';

@Component({
  templateUrl: 'advanced-date-input.component.html',
  standalone: false,
})
export class AdvancedDateInputComponent extends AbstractAdvancedInput implements OnInit {
  withTimeZone = false;
  readonly = false;

  ngOnInit() {
    this.withTimeZone = this.configuration.dataType === DataType.TimestampWithTimeZone;
    this.readonly = this.configuration.readonly;
  }
}
